import React from "react";

const RefundPolicy = () => {
  return (
    <div className="maindiv">
      <h2>Refund Policy</h2>
      <div className="termsandrivacydiv  pb-[40px]" >
        <p>
          {" "}
          Bhookr follows a strict no-refund policy for all subscription plans.
          Once a subscription is purchased, it cannot be canceled or refunded
          under any circumstances. This policy ensures operational efficiency
          and helps us maintain the highest standards of service and quality for
          our customers. We encourage you to carefully review the subscription
          details before making a purchase to ensure it aligns with your needs.
          For any assistance or clarification, our support team is available to
          help address your queries before you subscribe.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
